<template>
  <el-select
    :clearable="clearable"
    :disabled="disabled"
    filterable
    :value="value"
    @change="changeHandle"
  >
    <el-option
      v-for="(item, index) in baseDataOptionsList"
      :key="index"
      :value="item.value"
      :label="item.name"
    ></el-option>
  </el-select>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import baseDataMixin from './mixin.js';
import { selectTypeMapping } from '@/config';

export default {
  name: 'base-data-select',
  mixins: [baseDataMixin],
  props: {
    size: {
      type: String,
      default: 'normal',
    },
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    disabled: Boolean,
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      baseDataOptionsList: [],
    };
  },
  created() {
    if (this.label) {
      this.getOptionsList(this.label).then(list => {
        this.baseDataOptionsList = list;
      });
    }
  },
  methods: {
    changeHandle(val) {
      this.$emit('input', val);
      this.$emit('change', val);
    },
  },
};
</script>

